var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"variant":_vm.variant,"type":_vm.type,"size":_vm.size,"disabled":_vm.busy || _vm.disabled},on:{"click":_vm.handlerClick}},[(_vm.busy)?_c('b-spinner',{attrs:{"small":""}}):_c('span',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }